// ---- Swiper erst kurz vor dem Viewport initialisieren ----
const etxSwiperQueue = new WeakMap();
const etxSwiperObserver = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        etxSwiperObserver.unobserve(entry.target);
        const run = etxSwiperQueue.get(entry.target);
        etxSwiperQueue.delete(entry.target);
        if (run) run();
      });
    }, { rootMargin: '300px 0px' })
  : null;

function etxDeferSwiper(el, run) {
  if (!etxSwiperObserver) return run();
  if (etxSwiperQueue.has(el)) return; // wartet bereits
  etxSwiperQueue.set(el, run);
  etxSwiperObserver.observe(el);
}

// ---- CardLinkSlider im Header: Init erst beim Öffnen der Navigation ----
// Akzeptiert ein Element, eine NodeList oder ein Array von Panels/Slidern
function etxInitOrRefreshCardLinkSliders(scopes) {
  const list = !scopes
    ? [document]
    : (scopes instanceof Element || scopes === document) ? [scopes] : Array.from(scopes);

  list.forEach((scope) => {
    const sliders = scope.matches?.(".CardLinkSlider")
      ? [scope]
      : scope.querySelectorAll(".CardLinkSlider");

    sliders.forEach((el) => {
      // Panel noch ausgeblendet → später erneut (refreshHeaderCardLinkSliders ruft nach 300 ms nochmals auf)
      if (!el.getClientRects().length) return;

      if (el.swiper && !el.swiper.destroyed) {
        el.swiper.update();
        return;
      }

      new Swiper(el, {
        resizeObserver: false,
        updateOnWindowResize: false,
        observer: true,
        observeParents: true,
        watchOverflow: true,
        direction: "horizontal",
        slidesPerView: 1.55,
        spaceBetween: 20,
        centeredSlides: false,
        breakpoints: {
          560: { slidesPerView: 2 },
        },
      });
    });
  });
}
window.etxInitOrRefreshCardLinkSliders = etxInitOrRefreshCardLinkSliders;

function etxSwiper() {
  const withSafeLoop = (el, config) => {
    if (!config.loop) return config;

    const slideCount = el.querySelectorAll(":scope > .swiper-wrapper > .swiper-slide").length;
    let maxSpv = parseFloat(config.slidesPerView) || 1;

    if (config.breakpoints) {
      Object.values(config.breakpoints).forEach((bp) => {
        const spv = parseFloat(bp.slidesPerView) || 1;
        if (spv > maxSpv) maxSpv = spv;
      });
    }

    if (slideCount < Math.ceil(maxSpv) * 2) {
      const { loop, loopAdditionalSlides, ...rest } = config;
      return rest;
    }

    return config;
  };

  // CardLinkSlider (Header) fehlt hier absichtlich: Init erst beim Öffnen der Navigation
  const sliders = [
    {
      selector: ".SwiperTeasers:not(.small):not(.centered)",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        autoHeight: true,
        loop: false,
        watchOverflow: true,
        slideToClickedSlide: false,
        simulateTouch: true,
        breakpoints: {
          0: { slidesPerView: 1, slidesPerGroup: 1 },
          520: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 20 },
          1000: { slidesPerView: 2.5, slidesPerGroup: 2, spaceBetween: 20 },
          1200: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 20 },
        },
      },
    },
    {
      selector: ".SwiperTeasers:not(.small).centered",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        autoHeight: true,
        loop: false,
        watchOverflow: true,
        slideToClickedSlide: false,
        simulateTouch: true,
        breakpoints: {
          0: { slidesPerView: 1, slidesPerGroup: 1 },
          520: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 20 },
        },
      },
    },
    {
      selector: ".SwiperTeasers.small:not(.centered)",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        autoHeight: true,
        loop: false,
        watchOverflow: true,
        slideToClickedSlide: false,
        simulateTouch: true,
        breakpoints: {
          0: { slidesPerView: 1, slidesPerGroup: 1 },
          520: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 20 },
          1000: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 20 },
          1200: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 20 },
        },
      },
    },
    {
      selector: ".SwiperAmbassadors",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        autoHeight: true,
        loop: true,
        watchOverflow: true,
        slideToClickedSlide: true,
        simulateTouch: true,
        breakpoints: {
          0: { slidesPerView: 1, slidesPerGroup: 1 },
        },
        pagination: {
          type: "fraction",
        },
      },
    },
    {
      selector: ".SwiperCrossSelling",
      meta: true,
      config: {
        spaceBetween: 20,
        loop: false,
        breakpoints: {
          0: { slidesPerView: 1.25, slidesPerGroup: 1 },
          400: { slidesPerView: 1.75, slidesPerGroup: 1 },
          560: { slidesPerView: 2.15, slidesPerGroup: 2 },
          768: { slidesPerView: 2.75, slidesPerGroup: 2 },
          1000: { slidesPerView: 3, slidesPerGroup: 3 },
          1500: { slidesPerView: 4, slidesPerGroup: 4 },
        },
      },
    },
    {
      selector: ".SwiperMainProduct__images",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        autoHeight: true,
        loop: true,
        simulateTouch: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      thumbs: {
        selector: ".SwiperMainProduct__thumbs",
        config: {
          direction: "horizontal",
          autoplay: false,
          spaceBetween: 10,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          breakpoints: {
            0: { slidesPerView: 3 },
            1000: { slidesPerView: 4 },
            1200: { slidesPerView: 5 },
          },
        },
      },
    },
    {
      selector: ".SwiperProducts__images",
      controls: true,
      config: {
        direction: "horizontal",
        centeredSlides: true,
        watchOverflow: true,
        slideToClickedSlide: true,
        simulateTouch: true,
        effect: "creative",
        creativeEffect: {
          limitProgress: 10,
          prev: {
            rotate: [0, 0, -3],
            translate: ["-110%", "8.25%", 0],
            scale: "0.9",
            origin: "center bottom",
          },
          next: {
            rotate: [0, 0, 3],
            translate: ["110%", "8.25%", 0],
            scale: "0.9",
            origin: "center bottom",
          },
        },
        breakpoints: {
          0: { slidesPerView: 1.5, slidesPerGroup: 1 },
          768: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 20 },
        },
      },
      thumbs: {
        selector: ".SwiperProducts__content",
        config: {
          direction: "horizontal",
          autoplay: false,
        },
      },
    },
    {
      selector: ".SwiperIngredients__images",
      config: {
        direction: "horizontal",
        centeredSlides: true,
        watchOverflow: true,
        slideToClickedSlide: true,
        simulateTouch: true,
        effect: "creative",
        creativeEffect: {
          limitProgress: 10,
          prev: {
            rotate: [0, 0, -3],
            translate: ["-110%", "8.25%", 0],
            scale: "0.9",
            origin: "center bottom",
          },
          next: {
            rotate: [0, 0, 3],
            translate: ["110%", "8.25%", 0],
            scale: "0.9",
            origin: "center bottom",
          },
        },
        breakpoints: {
          0: { slidesPerView: 1.5, slidesPerGroup: 1 },
          768: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 20 },
        },
      },
      thumbs: {
        selector: ".SwiperIngredients__content",
        config: {
          direction: "horizontal",
          autoplay: false,
        },
      },
    },
    {
      selector: ".SwiperComboGalleryImages",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        spaceBetween: 20,
        watchOverflow: true,
        simulateTouch: true,
        breakpoints: {
          0: { slidesPerView: 1, slidesPerGroup: 1 },
          650: { slidesPerView: 2, slidesPerGroup: 2 },
          1000: { slidesPerView: 3, slidesPerGroup: 3 },
        },
      },
    },
    {
      selector: ".SwiperPublications",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: { delay: 3000, disableOnInteraction: false },
        spaceBetween: 20,
        slidesPerGroup: 1,
        loop: true,
        watchOverflow: true,
        simulateTouch: true,
        pagination: { dynamicBullets: true },
        breakpoints: {
          0: { slidesPerView: 2 },
          520: { slidesPerView: 3 },
          650: { slidesPerView: 4 },
          1000: { slidesPerView: 5 },
        },
      },
    },
    {
      selector: ".SwiperUSPs",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        spaceBetween: 20,
        slidesPerGroup: 1,
        loop: false,
        watchOverflow: true,
        simulateTouch: true,
        breakpoints: {
          0: { slidesPerView: 1.5 },
          520: { slidesPerView: 2 },
          650: { slidesPerView: 3 },
          1000: { slidesPerView: 4 },
        },
      },
    },
    {
      selector: ".SwiperUSPsCompact",
      controls: true,
      config: {
        direction: "horizontal",
        autoplay: false,
        spaceBetween: 20,
        slidesPerGroup: 1,
        loop: false,
        watchOverflow: true,
        simulateTouch: true,
        breakpoints: {
          0: { slidesPerView: 1.5 },
          520: { slidesPerView: 2 },
          1000: { slidesPerView: 3 },
          1200: { slidesPerView: 2 },
        },
      },
    },
  ];

  const baseConfig = {
    resizeObserver: true,
    updateOnWindowResize: true,
    watchOverflow: true,
  };

  sliders.forEach(({ selector, config, meta, controls, thumbs }) => {
    const setup = (el) => {
      if (el.swiper && !el.swiper.destroyed) {
        el.swiper.update();
        return;
      }

      let thumbsSwiper;
      const mergedConfig = withSafeLoop(el, { ...baseConfig, ...config });

      if (meta) {
        const id = el.getAttribute("data-swiper-id");
        const metaContainer = document.querySelector(`.Swiper__controls[data-swiper-id="${id}"]`);

        if (metaContainer) {
          const pag = metaContainer.querySelector(".swiper-pagination");
          if (pag) {
            mergedConfig.pagination = {
              ...(mergedConfig.pagination || {}),
              el: pag,
              clickable: true,
              type: "bullets",
            };
          }

          const prev = metaContainer.querySelector(".swiperArrowPrev");
          const next = metaContainer.querySelector(".swiperArrowNext");

          if (prev && next) {
            mergedConfig.navigation = { prevEl: prev, nextEl: next };
          }
        }
      }

      if (controls) {
        const id = el.getAttribute("data-swiper-id");
        const controlsEl = document.querySelector(`.Swiper__controls[data-swiper-id="${id}"]`);

        if (controlsEl) {
          const pag = controlsEl.querySelector(".Swiper__controls__pagination");
          if (pag) {
            mergedConfig.pagination = {
              type: "bullets",
              clickable: true,
              ...(mergedConfig.pagination || {}),
              el: pag,
            };
          }
        }
      }

      if (thumbs) {
        const parent = el.parentElement;
        const thumbsEl = parent ? parent.querySelector(thumbs.selector) : null;

        if (thumbsEl) {
          thumbsSwiper = new Swiper(thumbsEl, { ...baseConfig, ...thumbs.config });
          mergedConfig.thumbs = { swiper: thumbsSwiper };
        }
      }

      const mainSwiper = new Swiper(el, mergedConfig);

      if (selector === ".SwiperAmbassadors") {
        const swiperBackground = el.querySelector(".Swiper__background") ?? null;

        mainSwiper.on("beforeTransitionStart", function () {
          if (!swiperBackground) return;
          const activeSlide = this.slides[this.activeIndex];
          if (!activeSlide) return;

          const backgroundColorClass = activeSlide.dataset.brandColor || "background-color-black";
          swiperBackground.className = "Swiper__background " + backgroundColorClass;
        });
      }

      if (selector === ".SwiperProducts__images") {
        const containerBackground =
          el.closest(".Container")?.querySelector(".Container__background") ?? null;
        const brandStripes = el.querySelector(".BrandStripes") ?? null;
        const brandStripeItems = brandStripes
          ? Array.from(brandStripes.querySelectorAll(".BrandStripes__lines__item"))
          : [];

        mainSwiper.on("beforeTransitionStart", function () {
          const activeSlide = this.slides[this.activeIndex];
          if (!activeSlide) return;

          const backgroundColorClass = activeSlide.dataset.brandColor || "background-color-black";
          const brandstripesVariation = activeSlide.dataset.brandstripesVariation || "1";
          const brandstripesColors = activeSlide.dataset.brandstripesColors
            ? activeSlide.dataset.brandstripesColors.split(",")
            : ["transparent", "transparent", "transparent", "transparent"];

          if (containerBackground) {
            containerBackground.className = "Container__background " + backgroundColorClass;
          }

          if (brandStripes) {
            brandStripes.dataset.brandstripesVariation = brandstripesVariation;
          }

          brandstripesColors.forEach((color, index) => {
            if (!brandStripeItems[index]) return;
            brandStripeItems[index].style.setProperty("--brandstripe-color", color);
          });
        });
      }

      if (
        (selector === ".SwiperProducts__images" || selector === ".SwiperIngredients__images") &&
        thumbsSwiper
      ) {
        let syncing = false;

        mainSwiper.on("slideChangeTransitionEnd", () => {
          if (syncing) return;
          syncing = true;
          thumbsSwiper.slideTo(mainSwiper.activeIndex);
          syncing = false;
        });

        thumbsSwiper.on("slideChange", () => {
          if (syncing) return;
          syncing = true;
          if (typeof mainSwiper.slideToLoop === "function" && mainSwiper.params.loop) {
            mainSwiper.slideToLoop(thumbsSwiper.activeIndex);
          } else {
            mainSwiper.slideTo(thumbsSwiper.activeIndex);
          }
          syncing = false;
        });
      }
    };

    document.querySelectorAll(selector).forEach((el) => {
      if (el.swiper && !el.swiper.destroyed) {
        el.swiper.update(); // z. B. nach shopify:section:load
        return;
      }
      etxDeferSwiper(el, () => setup(el));
    });
  });

  // CardLinkSlider im Header nur bei offener Navigation nachführen
  if (!window.__etxCardLinkResizeHandler) {
    let resizeTimeout;
    window.__etxCardLinkResizeHandler = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (!document.documentElement.classList.contains("nav-show")) return;
        window.etxInitOrRefreshCardLinkSliders(document.querySelectorAll('.HeaderExpandable__inner'))
      }, 150);
    };
    window.addEventListener("resize", window.__etxCardLinkResizeHandler);
  }
}
